import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/dashboard/projects/$projectId/chats",
			params: { projectId: params.projectId },
		});
	},
});
